import React, { Component, Fragment } from 'react';
import Logo from './logo';
import TopMenu from './topMenu';
import MainMenu from './mainMenu';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { getUserInfoData } from "../../actions/userInfoAction";
import { getMenubarData } from "../../actions/menubarAction";
import IconBank from '../../app/iconBank';
import APP from 'app';
import Constants from 'constants';
import ProductList from './productList';

const { defaultLogo = '' } = APP.Utils.getConfig();
const { isMobile, fetchGlobal } = APP.Utils;
const {
    logo = ''
} = fetchGlobal();

class header extends Component {
    constructor() {
        super();
        this.state = {
            onSidebar: ''
        }
        this.sidebarHandler = this.sidebarHandler.bind(this);
    }

    componentDidMount() {
        this.props.getUserInfoData();
        this.props.getMenubarData({ isB2C: APP.Utils.isB2cClient() });
    }

    sidebarHandler = () => {
        this.setState({
            onSidebar: !this.state.onSidebar
        })
    }

    render() {
        const { userInfo = {}, fixedHeader = false, isB2C = false, isSearchPage = false, getMenubar = [], topMenu = [] } = this.props;
        const { additionalInfo = {} } = userInfo;
        const { lurl = '' } = additionalInfo;
        const { onSidebar = '' } = this.state;
        const logoUrl = lurl ? lurl : APP.Utils.isWhitelabel() ? logo : defaultLogo;
        return <Fragment>
            <div onClick={this.sidebarHandler} className="aside__mainbg">
                {IconBank({
                    id: 'asideMenubar',
                    name: 'asideMenubar',
                    className: 'aside__mainbg--icons'
                })}</div>
            <header className={onSidebar === true ? 'hotel__container asidebar__wrapper' : 'hotel__container asidebar__wrapper asidebar__wrapper--selected'}>
                <div className="one__fourth asidebar__wrapper--onefourth">
                    <Link to={`/hotel/`}>
                        <Logo
                            imageName={logoUrl}
                            className='logo__img'
                            altText='Logo here'
                        />
                    </Link>
                </div>
                <div className="three__fourth">
                    <TopMenu topMenu={topMenu} />
                    <nav className="nav">
                        <MainMenu getMenubar={getMenubar} />
                    </nav>
                </div>
            </header>
            <div onClick={this.sidebarHandler} className={onSidebar == true ? 'aside__overlay' : 'aside__overlay aside__overlay--selected'} ></div>
        </Fragment>
    }
};

const mapDispatchToProps = dispatch => ({
    getUserInfoData: () => {
        dispatch(getUserInfoData());
    },
    getMenubarData: payload => dispatch(getMenubarData(payload))
});

const mapStateToProps = state => {
    const { userinfos = {}, menubarList = {} } = state;
    const { getMenubar = [], topMenu = [] } = menubarList;

    const { userInfo = {} } = userinfos
    return {
        ...state,
        userInfo,
        getMenubar,
        topMenu
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(header);
